import { render } from "./PiedraPalantirView.vue?vue&type=template&id=63580ded"
import script from "./PiedraPalantirView.vue?vue&type=script&lang=js"
export * from "./PiedraPalantirView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__